import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { rejectCatchError } from "../../reject-catch-error";
import { ValidateAndSendCodeResponse } from "../../auth/interfaces/validate-and-send-code.response";
import { environment } from "environments/environment";

export const sendPhoneCodeThunk = createAsyncThunk('credit/sendCode', async (phoneNumber: string, { dispatch, rejectWithValue }) => {
    try {
        const response = await axios.post<ValidateAndSendCodeResponse>(environment.urls.validatePhone, { phoneNumber });
        return response.data;
    } catch (error: any) {
        return rejectCatchError(error, rejectWithValue);
    }
})